export enum Sort {
  AZ = 'a-z',
  ZA = 'z-a',
  CREATED = 'created',
  MODIFIED = 'modified',
  NAME = 'name',
  POPULAR = 'popular',
  TRENDING = 'trending',
  BESTMATCH = 'best-match',
  DATE_ADDED = 'date-added',
  PURCHASED = 'purchased',
  UPLOADED = 'uploaded',
  RECENT = 'recent',
}

export enum UploadAction {
  NEW = 'new',
  UPDATE = 'update',
  REMOVE = 'remove',
}

export interface ExpertContent {
  _id: string;
  entId: string;
  expertId: string;
  contentUrl: string;
  fileType: string;
  fileCategory: string;
  thumbnail: string;
  title: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  fileSize: number;
  isExternalFile: boolean;
  isPublic?: boolean;
}

export interface MediaLibraryState {
  loading: boolean;
  modalLoading: boolean;
  filters: {
    keyword: string;
    type: string[];
    sortBy: Sort;
  };
  count: number;
  page: number;
  perPage: number;
  filtersApplied: boolean;
  path: string;
  selectedFiles: string[];
  media: ExpertContent[];
  total: number;
  stroage: RemainingStorage;
}

export interface MediaResponse {
  result: ExpertContent[];
  total: number;
}

export interface FetchMediaPayload {
  payload: FetchMediaParams;
  type: string;
}

export interface FetchMediaParams {
  entId: string;
  keyword: string;
  path: string;
  type: string;
  sortBy: string;
  page: number;
  limit: number;
}

export interface Total {
  total: number;
}

export interface RemainingStorage {
  allowedStorage: number;
  mediaStorageSize: number;
  remainingStorage: number;
}

export interface MediaUploadPayload {
  payload: ExpertUploadMediaParam;
  type: string;
}

export interface IUploadMediaModalForm {
  expertId: string;
  entId: string;
  title: string;
  path: string;
  description: string;
  contentUrl: string;
  fileName: string;
  fileType: string;
  fileCategory: string | null;
  isExternalFile: boolean;
  thumbnailGenerated: string;
}
export interface CreateFolderForm {
  name: string;
}

export interface ExpertUploadMediaParam {
  expertId: string | null;
  entId: string;
  contentUrl: string;
  fileName: string;
  fileType: string;
  fileCategory: string | null;
  title: string;
  description: string;
  path: string;
  isExternalFile: boolean;
  thumbnailGenerated: string;
  resolve?: any;
  reject?: any;
}

export interface IMediaDeletePayload {
  id: string;
  contentUrl: string;
  fileSize: number;
}

export interface IMediaDelete {
  payload: IMediaDeletePayload;
  type: string;
}

export interface IMediaRequestDto {
  page: number;
  limit: number;
  keyword?: string;
  path?: string;
  type?: string[];
  ownership?: string;
}

export interface IMediaUpdate {
  id: string;
  isPublic?: boolean;
  thumbnailGenerated?: string;
}

export interface IMediaUpdatePayload {
  payload: IMediaUpdate;
  type: string;
}
export interface SaveDownloadVideoTrimmedParams {
  path: string;
  mediaId: string;
  isDownload: boolean;
  isTrimmed: boolean;
  startTime: string;
  endTime: string;
  resolve: any;
  reject: any;
}

export interface SaveDownloadVideoTrimmed {
  payload: SaveDownloadVideoTrimmedParams,
  type: string
}
